import React from 'react';
import PropTypes from 'prop-types';

import { Text, Icon } from 'components/common/Elements/Elements';

import classes from './TrueFalse.module.scss';

const TrueFalse = ({ value }) => {
  if (value) {
    return (
      <Text className={classes.iconWrap}>
        <span className={classes.visually_hidden}>used</span>
        <Icon icon="vBig" color="#1ecb85" height="16" />
      </Text>
    );
  }
  return (
    <Text className={classes.iconWrap}>
      <span className={classes.visually_hidden}>not used</span>
      <Icon icon="xBig" color="#d3d3d3" height="16" />
    </Text>
  );
};

TrueFalse.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      title: PropTypes.string,
      value: PropTypes.bool
    })
  ])
};

export default TrueFalse;
